// no-right-click.js
(function () {
  // Don't run inside the theme editor (so you can edit & preview)
  if (window.Shopify && window.Shopify.designMode) return;

  // Disable right-click (context menu)
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
  }, { passive: false });

  // Disable selection & dragging for most content (optional - keep if you want)
  function disableSelectionAndDrag() {
    try {
      document.addEventListener('selectstart', function (e) { e.preventDefault(); }, false);
      document.addEventListener('dragstart', function (e) { e.preventDefault(); }, false);
    } catch (err) {
      // ignore
    }
  }
  disableSelectionAndDrag();

  // Block common key combos: Ctrl/Cmd+U (view source), Ctrl/Cmd+S (save), Ctrl/Cmd+Shift+I (devtools),
  // Ctrl/Cmd+C (copy) — note: blocking copy may break user expectations
  document.addEventListener('keydown', function (e) {
    var key = e.key.toLowerCase();
    var ctrl = e.ctrlKey || e.metaKey; // metaKey for mac cmd
    // Examples: ctrl+u, ctrl+shift+i, ctrl+shift+c, ctrl+s, ctrl+c
    if (ctrl && (key === 'u' || key === 's' || (e.shiftKey && (key === 'i' || key === 'c')) || key === 'c')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    // F12
    if (e.keyCode === 123) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, false);
})();
